//----- Component --------------------------------------------------------/
// Developer : Daiana Curcio
// Creation Date : 05/08/2024
// Version : 1
// Description : Grafico de reclamos por motivos
//------Changes ----------------------------------------------------------//
// Change Date :
// Change by :
// Change description:
// Change Date :
// Change by :
// Change description:
//========================================================================/
import React, { useEffect, useState } from "react";
import { UrlApi } from "../../../../services/apirest";
import { PieChart } from "@mui/x-charts/PieChart";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Button from "@mui/material/Button";
import Dialog_motivos from "./Dialog_motivos";

function Grafico_motivos(props) {
  const [graficoMotivos, setGraficoMotivos] = useState([]);
  const { selectedDate } = props;

  const obtenerGraficoMotivos = () => {
    const formattedDate = selectedDate.format("YYYY"); // Formatear la fecha seleccionada
    fetch(UrlApi + "/reclamos/graficoMotivos/fecha/" + formattedDate)
      .then((data) => data.json())
      .then((data) => setGraficoMotivos(data));
  };

  useEffect(() => {
    obtenerGraficoMotivos();
  }, [selectedDate]);

  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  // console.log("GRAFICO MOTIVO", graficoMotivos);
  //------------------ Dialog --------------------------//
  const [abrirDialog, setAbrirDialog] = useState(false);

  const handleOpenDialog = () => {
    setAbrirDialog(true);
  };

  const handleCloseDialog = () => {
    setAbrirDialog(false);
  };
  //-------------------------------------------------//

  // Ordenar los datos de mayor a menor por cantidad de reclamos
  const graficoMotivosOrdenado = [...graficoMotivos].sort(
    (a, b) => b.cantidad_reclamos - a.cantidad_reclamos
  );

  // Calcular el total de reclamos
  const totalReclamos = graficoMotivosOrdenado.reduce(
    (total, item) => total + item.cantidad_reclamos,
    0
  );

  // Colores para cada segmento del gráfico
  const colors = [
    "#B8C1AE",
    "#F1A095",
    "#F1D295",
    "#A8CEF2",
    "#90B2EE",
    "#E7EEAA",
    "#AAEEEA",
    "#71F1EA",
    "#EECAD7",
    "#EBA3BC",
    "#D0F1B4",
    "#A6D7A6",
    "#8AB5A9",
    "#F25C47",
    "#4B7EB6",
    "#80B0EC",
    "#BA9BBD",
    "#C7DBD4",
  ];

  // Transformar los datos para el PieChart, incluyendo el color y el porcentaje
  const data = (graficoMotivosOrdenado || []).map((item, index) => ({
    label: `${item.descripcion_motivo} (${(
      (item.cantidad_reclamos / totalReclamos) *
      100
    ).toFixed(2)}%) - Tipo : ${item.valor}`,
    value: item.cantidad_reclamos,
    color: colors[index % colors.length], // Asignar color basado en el índice
  }));

  return (
    <div>
      <Paper
        elevation={3}
        sx={{
          p: { xs: 1, sm: 2 }, // padding: 8px en mobile, 16px en desktop
          width: "90%",
          maxWidth: { xs: "100%", md: "1000px" }, // ocupa todo en mobile, máx 800px en desktop
          mx: "auto", // centra en pantalla
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between", // separa título y botón
            marginBottom: 10,
          }}
        >
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: { xs: 16, sm: 20 }, // título más chico en mobile
              color: "#333",
            }}
          >
            Porcentaje por motivo
          </Typography>
          <Button
            variant="contained"
            size="small"
            endIcon={<FullscreenIcon />}
            onClick={handleOpenDialog}
            style={{ backgroundColor: "#007bff", color: "#fff" }}
          >
            Expandir
          </Button>
        </div>
        <div style={{ height: "250px", width: "100%" }}>
          <PieChart
            series={[
              {
                highlightScope: { faded: "global", highlighted: "item" },
                faded: {
                  innerRadius: 30,
                  additionalRadius: -30,
                  color: "#ddd",
                },
                data,
              },
            ]}
            color={data.map((d) => d.color)} // Asigna los colores al gráfico
            slotProps={{
              legend: {
                hidden: true, // Oculta la leyenda predeterminada
              },
            }}
          />
        </div>
        {abrirDialog ? (
          <Dialog_motivos
            abrirDialog={abrirDialog}
            onClose={handleCloseDialog}
            data={data}
            selectedDate={selectedDate}
          />
        ) : null}
      </Paper>
    </div>
  );
}

export default Grafico_motivos;
